var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-96 w-full mt-4 flex flex-col"},[_c('div',{staticClass:"space-y-2 px-2 w-full"},[_c('SpinnerSkeleton',{attrs:{"w":"76","h":"24"}}),_c('SpinnerSkeleton',{attrs:{"w":"76","h":"24"}}),_c('SpinnerSkeleton',{attrs:{"w":"76","h":"24"}}),_c('SpinnerSkeleton',{attrs:{"w":"76","h":"24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }